import React, {Fragment} from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'
import styles from './CopyToRoutesModal.scss'
import {Icon} from 'common/Icon'
import fetchJSON from 'lib/fetchJSON'
import {FancyCheckmark} from 'common/FancyCheckmark'
import {errorMessage} from 'lib/styleguide/base.scss'
import {getConsole} from 'lib/getConsole'
import {getCurrentUser, getBaseCurrentUser} from 'lib/utils'
import _ from 'lodash'
const console = getConsole('routes', 'CopyToRoutesModal')

export const COPY_TO_ROUTES_MODAL = 'COPY_TO_ROUTES_MODAL'

export class CopyToRoutesModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      visibility: _.get(getCurrentUser(), 'preferences.default_privacy_route', 1),
      name: `${props.troute.name} (copy)`,
      includePhotos: false,
      copyPending: false,
      copyResult: null,
      copyError: null
    }
  }

  onVisibilityChange = (e) => {
    this.setState({visibility: parseInt(e.target.value, 10)})
  }

  onNameChange = (e) => {
    this.setState({name: e.target.value})
  }

  onCopyPhotosChange = () => {
    this.setState({includePhotos: !this.state.includePhotos})
  }

  onSubmitForm = (e) => {
    e.preventDefault()
    this.onCopyConfirmed()
  }

  viewCopy = (e) => {
    const {copyResult} = this.state
    if (copyResult) {
      window.location = copyResult.url
    } else {
      console.error('viewCopy called without a successful copy result')
    }
  }

  onCopyConfirmed = () => {
    const {troute, objectType} = this.props
    const {name, visibility, includePhotos, copyPending, copyResult} = this.state
    if (copyPending || copyResult) { return }
    const params = {
      asset_type: objectType,
      privacy_code: troute.privacyCode,
      name,
      visibility,
      include_photos: this.canCopyPhotos(troute) && includePhotos
    }
    // the copy.json endpoint doesn't return the created route or even the
    // route ID, so it doesn't make sense to add it to lib/api/routes yet
    // (we have to do a full page navigation anyways)
    this.setState({copyPending: true})
    // DESPITE this sometimes being a trip ID and not a route ID, we still want
    // to use 'routes' in the URL.
    fetchJSON(`/routes/${troute.id}/copy.json`, params)
      .then(copyResult => this.setState({copyResult, copyError: null, copyPending: false}))
      .catch(copyError => this.setState({copyError, copyResult: null, copyPending: false}))
  }

  canCopyPhotos = (troute) => (
    troute.userId === getCurrentUser().id || (getBaseCurrentUser() && troute.userId === getBaseCurrentUser().id)
  )

  render () {
    const {onRequestClose, troute} = this.props
    const {visibility, name, includePhotos, copyResult, copyError, copyPending} = this.state

    return (
      <ConfirmationDialog
        title={<Fragment>Copy <strong>{troute.name}</strong></Fragment>}
        confirmText={copyResult ? 'View My Copy' : 'Copy to My Routes'}
        cancelText={copyResult ? 'Close' : 'Cancel'}
        confirmPending={copyPending}
        onConfirm={copyResult ? this.viewCopy : this.onCopyConfirmed}
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        maxWidth='550px'>
        <div className={styles.CopyToRoutesModal}>
          {!copyResult && <Fragment>
            <form onSubmit={this.onSubmitForm}>
              <label htmlFor='route-name'>Route Name</label>
              <input
                id='route-name'
                name='route-name'
                type='text'
                value={name}
                onChange={this.onNameChange} />
              <label htmlFor='route-visiblity'>Privacy</label>
              <select
                id='route-visibility'
                name='route-visibility'
                value={visibility}
                onChange={this.onVisibilityChange}>
                <option value='0'>Public</option>
                <option value='1'>Private</option>
                <option value='2'>Friends Only</option>
              </select>
              {this.canCopyPhotos(troute) && <div className={styles.inline}>
                <input id='copy-photos'
                  name='copy-photos'
                  type='checkbox'
                  value={includePhotos}
                  onChange={this.onCopyPhotosChange} />
                <label className={styles.labelInline} htmlFor='copy-photos'>Copy photos</label>
              </div>}
            </form>
            <p>
              Don't need to edit this route? Try adding it to your <a href='https://ridewithgps.com/help/pinning-and-sharing#pinning' target='_blank'>Pinned Routes</a> <Icon className={styles.helpIcon} i='help-circled' data-tip title='You can find Pinned Routes on your homepage, and in the Pinned section of the app' /> instead!
            </p>
          </Fragment>}
          {copyError && <div className={errorMessage}>
            Oops! There was an error copying the route. Please try again.
          </div>}
          {copyResult && <div>
            <FancyCheckmark />
            <strong>{name || '(unnamed)'}</strong> has been copied to your routes. Would you like to <a href={copyResult.url + '/edit'}>edit it in the Route Planner</a>?
            {includePhotos && <div><br />Your photos are being copied over, they will show up in a moment.</div>}
          </div>}
        </div>
      </ConfirmationDialog>
    )
  }
}
